import type { IconSvgObject } from './types';

const Attachment02Icon: IconSvgObject = [
  ["path", { d: "M8 8V6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6V18C16 20.2091 14.2091 22 12 22C9.79086 22 8 20.2091 8 18V13.5C8 12.1193 9.11929 11 10.5 11C11.8807 11 13 12.1193 13 13.5V16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Attachment02Icon;
